import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { motion } from 'framer-motion';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const SuccessModal = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: 4,
          padding: 4,
          background: 'linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
          maxWidth: '500px',
          width: '100%',
          overflow: 'hidden'
        }
      }}
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 2,
          padding: 0
        }}
      >
        <motion.div
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{
            type: 'spring',
            stiffness: 260,
            damping: 20,
            delay: 0.1
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: '#dcfce7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 2
            }}
          >
            <CheckCircleOutlineIcon sx={{ fontSize: 48, color: '#16a34a' }} />
          </Box>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: '#1e293b',
              marginBottom: 1
            }}
          >
            Application Submitted!
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <Typography
            variant="body1"
            sx={{
              color: '#64748b',
              marginBottom: 4,
              lineHeight: 1.6
            }}
          >
            Thank you for applying to the fellowship. We have received your
            details and will get back to you shortly.
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          style={{ width: '100%' }}
        >
          <Button
            variant="contained"
            fullWidth
            onClick={onClose}
            sx={{
              backgroundColor: '#16a34a',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '12px',
              fontSize: '1rem',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: '0 4px 12px rgba(22, 163, 74, 0.3)',
              '&:hover': {
                backgroundColor: '#15803d',
                boxShadow: '0 6px 16px rgba(22, 163, 74, 0.4)'
              }
            }}
          >
            Continue
          </Button>
        </motion.div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
